export const imageCodes = {
    art: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F4.jpg?alt=media&token=d0d41677-2da0-41e9-b25a-7c22a548235a"
    },

    art1: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5.jpg?alt=media&token=55d1e924-f20b-4eac-a288-e0c7e867c618"
    },
    
}

export const titleCodes = {
    aboutourart: {
        code: "${merchantId}_tmpl_title_11",
        title: "About Our Artisan "
    },

   
}

export const textCodes = {
    aboutus: {
        code: "${merchantId}_tmpl_text_1",
        text: "Phyo's Handmade is a local brand that empowers artisans and helps people in need in Myanmar. Your purchases support the work of 20+ talented young artisans from different regions of Myanmar. Each of the products is personally created with love. Furthermore, a portion of the proceeds from every sale will be donated to children in need. Every product that you purchase helps make a difference. Help us spread the love to those who need it most. Your support means a lot to us."
    },

        
}